import type { FluxErrorEntityErrorCodes } from '../types.js';

export const FeaturesErrorCodes = {
  FeatureNotAvailableToAccount: {
    code: 'feature/not-available-to-account',
    message: 'Este módulo não está disponível para a sua conta.',
    explanation: 'O recurso que você está tentando acessar não está disponível para sua conta.',
    localizations: {},
  },
  FeatureNotFound: {
    code: 'feature/not-found',
    message: 'Módulo não encontrado.',
    explanation: 'O recurso que você está tentando acessar não foi encontrado.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'feature'>;
